import { CALENDAR_TYPES } from '@/views/constants'
/*
  original calendar providers,
  collects as "simple" calendar info, inside Calendar entity constructor
 */
export default class CalendarOriginalProviders {
  constructor (options = {}, providerId = 0, calendarType = CALENDAR_TYPES.PRACTICE_TYPE) {
    this.list = this.getProviders(options, calendarType).filter(p => p).map(p => {
      const name = this.getProviderName(p)
      return {
        id: p.id,
        firstname: p.firstname,
        lastname: p.lastname,
        middlename: p.middlename,
        prefix: p.prefix,
        suffix: p.suffix,
        siteSpecialties: p.site_specialties,
        name: name,
        text: name,
        sortId: p.sort_id,
        media: p?.media?.PROFILE?.[0] ?? null
      }
    })
    this.current = this.getCurrentProviderFromArray(providerId, this.list) || null
  }

  getProviders (options, type) {
    if ([CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.PROVIDER_TYPE].includes(type)) {
      return [options.doctor]
    } else if ([CALENDAR_TYPES.LOCATION_TYPE].includes(type)) {
      return (options?.location?.doctor_locations || []).flatMap(docLocs => docLocs.doctor)
    } else if ([CALENDAR_TYPES.PRACTICE_TYPE].includes(type)) {
      return options?.practice?.doctors || []
    }
  }

  getProviderName (provider) {
    const providerNameProperties = ['prefix', 'firstname', 'middlename', 'lastname', 'suffix']
    return providerNameProperties.reduce((acc, val) => {
      const part = provider[val]
      return part && part.length ? [...acc, provider[val]] : acc
    }, []).join(' ')
  }

  getCurrentProviderFromArray (providerId, providerArray) {
    return providerArray.find(provider => +provider.id === +providerId)
  }

  addToArrayIfExists (array, object, part) {
    if (object[part]) {
      array.push(object[part])
    }
    return array
  }
}
